import { assets } from '@/ui/assets'
import { TokenIcon } from '@/ui/atoms/token-icon/TokenIcon'
import { AlertTriangle } from 'lucide-react'

import { ActionRow } from '../../components/action-row/ActionRow'
import { UpDownMarker } from '../../components/action-row/UpDownMarker'
import { ActionRowBaseProps } from '../../components/action-row/types'
import { getFormattedValue } from '../../components/action-row/utils'
import { IsolatedLendWithdrawAction } from './types'

export interface IsolatedLendWithdrawActionRowProps extends ActionRowBaseProps {
  action: IsolatedLendWithdrawAction
}

export function IsolatedLendWithdrawActionRow({
  index,
  action,
  actionHandlerState,
  onAction,
  variant,
}: IsolatedLendWithdrawActionRowProps) {
  const status = actionHandlerState.status
  const formattedValue = getFormattedValue(action.value, action.token, variant)
  const hasLiquidityCap =
    action.requestedValue !== undefined && action.poolAvailable !== undefined && action.value.lt(action.requestedValue)

  return (
    <ActionRow index={index}>
      <ActionRow.Icon path={assets.actions.withdraw} actionStatus={status} />

      <ActionRow.Title icon={<TokenIcon token={action.token} className="h-6" />} actionStatus={status}>
        Withdraw {formattedValue}
        {hasLiquidityCap && (
          <span className="flex items-center gap-1.5 text-amber-400 text-xs">
            <AlertTriangle className="h-3.5 w-3.5" />
            <span>Pool liquidity caps this withdraw at {formattedValue}.</span>
          </span>
        )}
      </ActionRow.Title>

      <ActionRow.Description successMessage={`Withdrew ${formattedValue}!`} actionStatus={status} variant={variant}>
        <UpDownMarker token={action.token} value={action.value} direction="up" />
      </ActionRow.Description>

      <ActionRow.ErrorWarning variant={variant} actionHandlerState={actionHandlerState} />

      <ActionRow.Action onAction={onAction} status={status}>
        Withdraw
      </ActionRow.Action>
    </ActionRow>
  )
}
